import {useHits, UseHitsProps} from 'react-instantsearch';
import {ProductCard} from '~/components/cards/ProductCard.client';

const ProductHit = ({hit}: any) => {
  if (hit?.meta?.custom?.online_variant_prices) {
    Object.keys(hit?.meta?.custom?.online_variant_prices).forEach((sku) => {
      const price = hit?.meta?.custom?.online_variant_prices[sku];
      if (price < hit.price) hit.price = price;
    });
  }
  const productProps: any = {
    ...hit,
    variants: {
      nodes: [
        {
          id: hit.objectID,
          compareAtPrice: hit.compare_at_price,
          compareAtPriceV2: {amount: hit.compare_at_price, currencyCode: 'USD'},
          priceV2: {amount: hit.price, currencyCode: 'USD'},
          selectedOptions: [],
          title: hit.title,
        },
      ],
    },
  };

  if (hit.image) {
    productProps.featuredImage = {
      alt: hit.title,
      height: 2048,
      position: 1,
      src: hit.image,
      url: hit.image,
      width: 2048,
    };
  }
  return <ProductCard product={productProps} />;
};

export const ProductHits = (props: UseHitsProps) => {
  const {hits} = useHits(props);

  return hits?.length > 0 ? (
    <div className="grid grid-cols-2 lg:grid-cols-3 gap-1">
      {hits.map((hit: any) => (
        <ProductHit key={hit.objectID} hit={hit} />
      ))}
    </div>
  ) : (
    <p className="font-sans text-16/24 max-w-[500px] text-start">No results</p>
  );
};
